function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import { Divider, Skeleton, Button, Modal, Space, Spin, Alert, message, Tabs } from 'antd';
import Common from "../components/includes/Common";
import NewUserForm from "../components/forms/NewUserForm";
import { TrashFill, PencilFill, Plug, PeopleFill, PersonPlusFill, EyeSlashFill, EyeFill, ExclamationCircleFill } from 'react-bootstrap-icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;

var PlatformUsersManagement = function PlatformUsersManagement() {
  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      isDataLoading = _useState2[0],
      setIsDataLoading = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      users = _useState4[0],
      setUsers = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isNewUserCreated = _useState6[0],
      setIsNewUserCreated = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      selectedUser = _useState8[0],
      setSelectedUser = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isDataUpdated = _useState10[0],
      setIsDataUpdated = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      isProcessing = _useState12[0],
      setIsProcessing = _useState12[1];

  var _useState13 = useState(''),
      _useState14 = _slicedToArray(_useState13, 2),
      operationSuccessMessage = _useState14[0],
      setOperationSuccessMessage = _useState14[1];

  var _useState15 = useState(''),
      _useState16 = _slicedToArray(_useState15, 2),
      operationErroMessage = _useState16[0],
      setOperationErrorMessage = _useState16[1];

  var handleDelete = function handleDelete(u) {
    setSelectedUser(u);
    confirm({
      title: 'Confirmez-vous ?',
      icon: /*#__PURE__*/_jsx(ExclamationCircleFill, {}),
      content: 'La supression de ' + u.firstname + '?',
      onOk: function onOk() {
        setIsProcessing(true);
        axios.post(Common.baseApiUrl + 'deleteuser/' + u.id.toString() + '/' + Common.currentUser.id).then(function (response) {
          setIsProcessing(false);

          if (response.data.status == 200) {
            setOperationSuccessMessage(response.data.message);
            setIsDataUpdated(true);
          } else {
            setOperationErrorMessage(response.data.message);
          }
        })["catch"](function (error) {
          setIsProcessing(false);
          setOperationErrorMessage(response.data.message);
        }).then(function () {
          setIsDataUpdated(false);
        });
      },
      onCancel: function onCancel() {
        console.log('Cancel');
      }
    });
  };

  var handleEdit = function handleEdit(u) {};

  var handleSwitch = function handleSwitch(u) {
    var action = u.status == 1 ? 'Bloquage' : 'Débloquage';
    Modal.confirm({
      title: 'Confirmation ',
      content: action + ' de ' + u.firstname + ' ' + u.lastname,
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + 'witchuserstatus', {
          current: u.status,
          aid: Common.currentUser.id,
          uid: u.id
        }).then(function (response) {
          if (response.data.status == 200) {
            setIsDataUpdated(true);
            message.success({
              content: response.data.message,
              delay: 4
            });
          } else {
            message.error({
              content: response.data.message,
              delay: 4
            });
          }
        })["catch"](function (error) {
          message.error({
            content: 'Une erreur est survenue',
            delay: 4
          });
        });
      }
    });
  };

  useEffect(function () {
    setIsNewUserCreated(false);
    setIsDataUpdated(false);
    axios.get(Common.baseApiUrl + 'getplatformusers/' + Common.currentUser.id).then(function (response) {
      setIsDataLoading(false);
      setUsers(response.data.users);
    })["catch"](function (error) {
      setIsDataLoading(false);
    });
  }, [isNewUserCreated, isDataUpdated]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 9,
          md: 10,
          children: /*#__PURE__*/_jsxs(Tabs, {
            animated: true,
            defaultActiveKey: 1,
            children: [/*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(PeopleFill, {
                  size: 30
                }), "UTILISATEURS"]
              }),
              children: /*#__PURE__*/_jsxs("div", {
                className: "white-bg cool-radius",
                children: [/*#__PURE__*/_jsx(Space, {
                  direction: "horizontal",
                  children: isProcessing && /*#__PURE__*/_jsx(Spin, {})
                }), operationSuccessMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
                  type: "success",
                  message: operationSuccessMessage,
                  showIcon: true
                }), operationErroMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
                  type: "error",
                  message: operationErroMessage,
                  showIcon: true
                }), /*#__PURE__*/_jsx(Divider, {}), isDataLoading ? /*#__PURE__*/_jsx(Skeleton, {
                  active: true
                }) : /*#__PURE__*/_jsx(_Fragment, {
                  children: /*#__PURE__*/_jsxs(Table, {
                    responsive: true,
                    children: [/*#__PURE__*/_jsx("thead", {
                      children: /*#__PURE__*/_jsxs("tr", {
                        children: [/*#__PURE__*/_jsx("th", {
                          children: "Login"
                        }), /*#__PURE__*/_jsx("th", {
                          children: "Pr\xE9nom"
                        }), /*#__PURE__*/_jsx("th", {
                          children: "Nom"
                        }), /*#__PURE__*/_jsx("th", {
                          children: "Role"
                        }), /*#__PURE__*/_jsx("th", {}), /*#__PURE__*/_jsx("th", {}), /*#__PURE__*/_jsx("th", {})]
                      })
                    }), /*#__PURE__*/_jsx("tbody", {
                      children: users.map(function (u) {
                        return /*#__PURE__*/_jsxs("tr", {
                          children: [/*#__PURE__*/_jsx("td", {
                            children: u.mobile.slice(3)
                          }), /*#__PURE__*/_jsx("td", {
                            children: u.firstname
                          }), /*#__PURE__*/_jsx("td", {
                            children: u.lastname
                          }), /*#__PURE__*/_jsxs("td", {
                            children: [u.role == 11 && 'Caisse', u.role == 21 && 'Consultation 1', u.role == 22 && 'Consultation 2', u.role == 23 && 'Consultation 3', u.role == 24 && 'Consultation 4', u.role == 31 && 'Exploration', u.role == 41 && 'Pharmacie & Lunetterie', u.role == 51 && 'Chirurgie', u.role == 61 && 'Laser', u.role == 71 && 'Facturation', u.role == 81 && 'Manager', u.role == 91 && 'Administrateur']
                          }), /*#__PURE__*/_jsxs("td", {
                            children: [" ", /*#__PURE__*/_jsx(Button, {
                              type: "default",
                              onClick: function onClick() {
                                handleSwitch(u);
                              },
                              children: u.status == 1 ? /*#__PURE__*/_jsx(EyeFill, {
                                size: 22
                              }) : /*#__PURE__*/_jsx(EyeSlashFill, {
                                size: 22
                              })
                            })]
                          }), /*#__PURE__*/_jsx("td", {
                            children: /*#__PURE__*/_jsx(Button, {
                              type: "default",
                              onClick: function onClick() {
                                handleDelete(u);
                              },
                              children: /*#__PURE__*/_jsx(TrashFill, {
                                size: 22
                              })
                            })
                          }), /*#__PURE__*/_jsx("td", {
                            children: /*#__PURE__*/_jsx(Button, {
                              type: "default",
                              onClick: function onClick() {
                                handleEdit(u);
                              },
                              children: /*#__PURE__*/_jsx(PencilFill, {
                                size: 22
                              })
                            })
                          })]
                        }, u.id);
                      })
                    })]
                  })
                })]
              })
            }, 1), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(PersonPlusFill, {
                  size: 30
                }), " AJOUTER UN UTILISATEUR"]
              }),
              children: /*#__PURE__*/_jsx("div", {
                className: "cool-radius white-bg",
                children: /*#__PURE__*/_jsx(NewUserForm, {
                  handleUpdate: function handleUpdate() {
                    setIsNewUserCreated(true);
                  }
                })
              })
            }, 3)]
          })
        })
      })
    })
  });
};

export default PlatformUsersManagement;